module.exports = __webpack_public_path__ + "img/lottery_bg_0.282bb402.png";